angular.module 'app'
.controller 'TopNewController', ($scope, $http, $state, $stateParams, $sce, $ionicPopup, config, activeUser) ->
  $scope.ui =
    baseUrl: config.api.baseUrl
    homepage: activeUser.homepage
    userInfo: activeUser.user
    topNew: {}
    content_html: null

  do findAd = ->
    $http.get "#{config.api.baseUrl}/cumpus/headline/#{$stateParams.new_id}",
      params:
        group_id: activeUser.group_id
    .then (res) ->
      $scope.ui.topNew = res.data
      $scope.ui.topNew.content = $scope.ui.topNew.content.replace(/\"http\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\(http\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\&quot;http\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=http://mmbiz.qpic.cn').replace(/\"https\:\/\/mmbiz.qpic.cn/g, '"' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\(https\:\/\/mmbiz.qpic.cn/g, '(' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn').replace(/\&quot;https\:\/\/mmbiz.qpic.cn/g, '&quot;' + config.api.baseUrl + '/imgserve?_url=https://mmbiz.qpic.cn')
      $scope.ui.content_html = $sce.trustAsHtml $scope.ui.topNew.content
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )
